import getActualKeyFromKey from './GetActualKeyFromKey';
import getFinanceNameFromKey from './GetFinanceNameFromKey';
import { getDefaultTerm, getDefaultMileage, getDefaultDeposit } from './GetDefaults';

/**
 * Helper method to return an object representing the keys we want to show on the used more details page. We can order the keys here, change the short and long name, set the fallback mileage/deposit/terms if the CW request fails to get that key, and determine if the finance option should show if the key is not available for the vehicle
 * @param {object} vehicle
 */
export default function(vehicle) {
    let data = [];

    if (vehicle.is_new == 0) {
        let keyOfInterest = (vehicle.brand == 'vauxhall') ? 'VAUXHALL_PCP_ONLY' : 'PSA_PCP_ONLY';
        data.push({
            key: getActualKeyFromKey(keyOfInterest),
            name: getFinanceNameFromKey(vehicle, keyOfInterest),
            shortName: getFinanceNameFromKey(vehicle, keyOfInterest, true),
            longName: getFinanceNameFromKey(vehicle, keyOfInterest),
            order: 1,
            defaultTerm: getDefaultTerm(vehicle.brand, keyOfInterest),
            defaultMileage: getDefaultMileage(vehicle.brand, keyOfInterest),
            defaultDeposit: getDefaultDeposit(vehicle.brand, keyOfInterest),
            mileage: true,
            alwaysShow: true,
            fallbackDeposit: {
                min: 0,
                max: (vehicle.vat_price * 0.7),
            },
            fallbackTerms: [
                25,
                31,
                36,
                42,
                48,
            ],
            fallbackMileages: [
                6000,
                7000,
                8000,
                9000,
                10000,
                11000,
                12000,
                13000,
                14000,
                15000,
                16000,
                17000,
                18000,
                19000,
                20000,
                21000,
                22000,
                23000,
                24000,
                25000,
                26000,
                27000,
                28000,
                29000,
                30000,
            ],
        });

        data.push({
            key: getActualKeyFromKey('DSG_PCP_ONLY'),
            name: getFinanceNameFromKey(vehicle, 'DSG_PCP_ONLY'),
            shortName: getFinanceNameFromKey(vehicle, 'DSG_PCP_ONLY', true),
            longName: 'Personal Contract Purchase',
            order: 2,
            defaultTerm: getDefaultTerm(vehicle.brand, 'DSG_PCP_ONLY'),
            defaultMileage: getDefaultMileage(vehicle.brand, 'DSG_PCP_ONLY'),
            defaultDeposit: getDefaultDeposit(vehicle.brand, 'DSG_PCP_ONLY'),
            mileage: true,
            alwaysShow: true,
            fallbackDeposit: {
                min: 0,
                max: (vehicle.vat_price * 0.7),
            },
            fallbackTerms: [
                25,
                31,
                36,
                42,
                48,
            ],
            fallbackMileages: [
                6000,
                7000,
                8000,
                9000,
                10000,
                11000,
                12000,
                13000,
                14000,
                15000,
                16000,
                17000,
                18000,
                19000,
                20000,
                21000,
                22000,
                23000,
                24000,
                25000,
                26000,
                27000,
                28000,
                29000,
                30000,
            ],
        });
    } else {
        data.push({
            key: getActualKeyFromKey('OVERAGE_PCP_ONLY'),
            name: getFinanceNameFromKey(vehicle, 'OVERAGE_PCP_ONLY'),
            shortName: getFinanceNameFromKey(vehicle, 'OVERAGE_PCP_ONLY', true),
            longName: getFinanceNameFromKey(vehicle, 'OVERAGE_PCP_ONLY'),
            order: 1,
            defaultTerm: getDefaultTerm(vehicle.brand, 'OVERAGE_PCP_ONLY'),
            defaultMileage: getDefaultMileage(vehicle.brand, 'OVERAGE_PCP_ONLY'),
            defaultDeposit: getDefaultDeposit(vehicle.brand, 'OVERAGE_PCP_ONLY'),
            mileage: true,
            alwaysShow: true,
            fallbackDeposit: {
                min: 0,
                max: (vehicle.vat_price * 0.7),
            },
            fallbackTerms: [
                25,
                31,
                37,
                42,
                48,
            ],
            fallbackMileages: [
                6000,
                7000,
                8000,
                9000,
                10000,
                12000,
                15000,
                20000,
                25000,
            ],
        });
    }

    data.push({
        key: getActualKeyFromKey('HP'),
        name: getFinanceNameFromKey(vehicle, 'HP'),
        shortName: getFinanceNameFromKey(vehicle, 'HP', true),
        longName: getFinanceNameFromKey(vehicle, 'HP'),
        order: 3,
        defaultTerm: getDefaultTerm(vehicle.brand, 'HP'),
        defaultMileage: getDefaultMileage(vehicle.brand, 'HP'),
        defaultDeposit: getDefaultDeposit(vehicle.brand, 'HP'),
        mileage: false,
        alwaysShow: true,
        fallbackDeposit: {
            min: 0,
            max: (vehicle.vat_price * 0.7),
        },
        fallbackTerms: [
            12,
            18,
            24,
            30,
            36,
            42,
            48,
            54,
            60,
        ],
        fallbackMileages: [],
    });

    return data;
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/finance/ProductsOfInterest.js